"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.iconComponentPropTypes = exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Platform = _interopRequireDefault(require("react-native-web/dist/cjs/exports/Platform"));
var _View = _interopRequireDefault(require("react-native-web/dist/cjs/exports/View"));
var _useWindowDimensions = _interopRequireDefault(require("react-native-web/dist/cjs/exports/useWindowDimensions"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ThemeProvider = require("../ThemeProvider");
var _utils = require("../utils");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const Icon = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  let {
    icon: IconComponent,
    accessibilityLabel,
    variant,
    tokens,
    scalesWithText = false,
    style = {},
    dataSet
  } = _ref;
  const themeTokens = (0, _ThemeProvider.useThemeTokens)('Icon', tokens, variant);
  const {
    fontScale
  } = (0, _useWindowDimensions.default)();
  const size = scalesWithText ? themeTokens.size * fontScale : themeTokens.size;
  const iconContent = /*#__PURE__*/(0, _jsxRuntime.jsx)(IconComponent, {
    title: accessibilityLabel,
    size: size,
    color: themeTokens.color,
    gradient: themeTokens.gradient
  });
  const paddingStyles = variant?.padding ? {
    padding: themeTokens.width,
    width: themeTokens.size + themeTokens.width * 2,
    // sets the diameter of the circle which is the size of the icon plus twice the general padding established to obtain a perfect circle
    height: themeTokens.size + themeTokens.width * 2
  } : {};
  const getIconContentForMobile = () => {
    if (Object.keys(paddingStyles).length) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_View.default, {
        style: {
          backgroundColor: themeTokens.backgroundColor,
          borderRadius: themeTokens.borderRadius,
          ...paddingStyles
        },
        children: iconContent
      });
    }
    return iconContent;
  };
  return _Platform.default.OS === 'web' ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_View.default, {
    ref: ref
    // eslint-disable-next-line react-native/no-inline-styles
    ,
    style: {
      // TODO: systematise animations.
      // https://github.com/telus/universal-design-system/issues/487
      transition: 'transform 200ms, color 200ms',
      transform: [themeTokens.scale ? `scale(${themeTokens.scale})` : '', themeTokens.translateX ? `translateX(${themeTokens.translateX}px)` : '', themeTokens.translateY ? `translateY(${themeTokens.translateY}px)` : ''].filter(exists => exists).join(' '),
      ...style,
      backgroundColor: themeTokens.backgroundColor,
      borderRadius: themeTokens.borderRadius,
      paddingTop: themeTokens.paddingTop,
      ...paddingStyles
    },
    dataSet: dataSet,
    children: iconContent
  }) : getIconContentForMobile();
});
Icon.displayName = 'Icon';
const iconComponentPropTypes = exports.iconComponentPropTypes = {
  variant: _utils.variantProp.propType,
  tokens: (0, _utils.getTokensPropType)('Icon'),
  /**
   * Descriptive label used in web SVG title tag for accessibility
   */
  accessibilityLabel: _propTypes.default.string,
  /**
   * controls whether the icon size should be proportionate to any accessibility-related font scaling.
   */
  scalesWithText: _propTypes.default.bool,
  /**
   * Custom style object to be applied to the icon component.
   * This is useful for overriding the default icon style but for cases where desires styles are not available as tokens.
   *
   * Note: This prop is only used in web.
   *
   * @example
   * <Icon style={{ color: 'red' }}
   */
  style: _propTypes.default.object
};
Icon.propTypes = {
  ...iconComponentPropTypes,
  /**
   * A valid UDS icon component imported from a UDS palette
   * (e.g.) `import { MyIcon } from @telus-uds/palette-<brand>/build/web/icons`
   */
  icon: _propTypes.default.elementType.isRequired
};
var _default = exports.default = Icon;